import { render } from "./WinnersIndividual.vue?vue&type=template&id=1242a2e2&scoped=true"
import script from "./WinnersIndividual.vue?vue&type=script&lang=js"
export * from "./WinnersIndividual.vue?vue&type=script&lang=js"

import "./WinnersIndividual.vue?vue&type=style&index=0&id=1242a2e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1242a2e2"

export default script